import Tooltip from "@material-ui/core/Tooltip";
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
export class UpdateButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onClick: props.onClick,
            caption: props.caption,
            hideToolTip: props.hideToolTip,
        };
    }

    onClick() {
        if (this.state.onClick) {
            this.state.onClick();
        }
    }
    render() {
        return (
            <span
                style={{
                    cursor: "pointer",
                    fontSize: "x-larger",
                    // marginRight: "0.5em",
                    float: "right",
                }}
            >
                {this.state.hideToolTip ?
                    <Button
                        className="add"
                        size="small"
                        onClick={this.onClick.bind(this)}
                        style={{
                            background: "#0B6F9D",
                            color: "white",
                            fontSize: "x-larger",
                            textTransform: "capitalize",
                            cursor: "pointer",
                            float: "right",
                            padding: "6px"
                            // margin: "0.2em 0.5em 0.3em 0em",
                            // marginRight: "1rem",
                            // marginBottom: "1em",
                        }}
                    >
                        Update Category Sequense
                    </Button>
                    :
                    <Tooltip title="Save">
                        <Button
                            className="add"
                            size="small"
                            onClick={this.onClick.bind(this)}
                            style={{
                                background: "#0B6F9D",
                                color: "white",
                                fontSize: "x-larger",
                                textTransform: "capitalize",
                                cursor: "pointer",
                                float: "right",
                                padding: "6px"
                                // margin: "0.2em 0.5em 0.3em 0em",
                                // marginRight: "1rem",
                                // marginBottom: "1em",
                            }}
                        >
                            Update Category Sequense
                        </Button>
                    </Tooltip>
                }
            </span>
        );
    }
}
export default UpdateButton;
